"use client"

import React, { useState, useRef, useEffect } from "react";
import { useRouter } from "next/navigation";
import { FormattedMessage, useIntl } from 'react-intl';

import PAGES from "@/constants/pages";

const StartCustomDomain = ({ buttonColor = "primary" }) => {
  const intl = useIntl();
  const router = useRouter();
  const [value, setValue] = useState("");

  const elementsRef = useRef({});

  const setRef = (key) => (el) => {
    elementsRef.current[key] = el;
  };

  const handleDomainChange = (e) => {
    setValue(e.target.value);
  };

  const handleButtonClick = () => {
    const params = new URLSearchParams();
    params.set('domain', value);

    if (!!value) {
      router?.push(`${PAGES.createProfile}?${params.toString()}`);
    } else {
      router?.push(PAGES.createProfile);
    }
  };

  useEffect(() => {
    if (elementsRef.current["inputMirror"] && elementsRef.current["input"]) {
      const inputMirrorWidth = elementsRef.current["inputMirror"]?.offsetWidth;
      const containerWidth = elementsRef.current["container"]?.offsetWidth;
      const sufixWidth = elementsRef.current["sufix"]?.offsetWidth;
      const buttonWidth = elementsRef.current["button"]?.offsetWidth;
      if ((inputMirrorWidth + sufixWidth) < (containerWidth - ((buttonWidth / 3) + buttonWidth))) {
        elementsRef.current["input"].style.width = `${inputMirrorWidth + 5}px`;
      }
    }
  }, [value]);

  return (
    <div
      ref={setRef('container')}
      className="relative flex justify-between items-center border border-gray-300 rounded-lg w-full max-w-sm p-2"
    >
      <span className="flex items-center gap-0">
        <span
          ref={setRef('inputMirror')}
          className="absolute top-0 left-0 min-w-[20px] invisible whitespace-pre font-inherit p-0"
        >
          {value || intl.formatMessage({ id: "home-page-start-custom-domain-input-placeholder" })}
        </span>
        <input
          ref={setRef('input')}
          type="text"
          value={value}
          placeholder={intl.formatMessage({ id: "home-page-start-custom-domain-input-placeholder" })}
          onChange={handleDomainChange}
          className="text-primary w-24 bg-transparent outline-none text-ellipsis"
        />
        <span
          ref={setRef('sufix')}
        >
          .downfor.life
        </span>
      </span>
      <button
        ref={setRef('button')}
        onClick={handleButtonClick}
        className={`text-white end-2.5 bottom-2.5 rounded-md bg-${buttonColor} hover:bg-${buttonColor}/90 font-bold rounded-lg text-sm px-4 py-2`}
      >
        <FormattedMessage
          id="home-page-start-custom-domain-button"
        />
      </button>
    </div>
  )
};

export default StartCustomDomain;
